import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { listerClickThrough } from '../../../../actions/lister-actions';
import AddToBasketButton from '../../../ProductCard/AddToBasket/AddToBasketButton';
import BackInStockButton from '../../../ProductCard/BackInStockButton';
import BrandLogo from '../../../ProductCard/BrandLogo';
import Bullets from '../../../ProductCard/Bullets';
import DeliveryInformation from '../../../ProductCard/DeliveryInformation';
import EnergyInformation from '../../../ProductCard/EnergyInformation/EnergyInformation';
import ExVat from '../../../ProductCard/ExVat';
import Heading from '../../../ProductCard/Heading';
import MoreInfo from '../../../ProductCard/MoreInfo';
import PricePod from '../../../ProductCard/PricePod/PricePod@default';
import ProductImage from '../../../ProductCard/ProductImage/ProductImage';
import PromoFlag from '../../../ProductCard/PromoFlag';
import ReviewRating from '../../../ProductCard/ReviewRating/ReviewRating';
import StockStatus from '../../../ProductCard/StockStatus';
import { Context } from '../../store/store';
import SmallListViewSkeleton from './Skeletons/SmallListViewSkeleton';

const SmallListViewContent = ({ product }) => {
	const [contextState] = useContext(Context);
	const { loaded } = contextState;

	const { DeliveryPricingInPricePod } = useSelector(
		(state) => state.featureSwitches
	);

	const dispatch = useDispatch();

	if (!product) {
		return null;
	}

	if (!loaded) {
		return <SmallListViewSkeleton />;
	}

	return (
		<React.Fragment>
			<div className="w-5/12 pr-2">
				<ProductImage {...product} />

				<EnergyInformation
					classes="text-center mt-4"
					energyRatingDetails={product.EnergyRatingDetails}
				/>
			</div>

			<div className="w-7/12">
				<a
					href={product.FullProductUrl}
					onClick={(event) => {
						event.preventDefault();
						window.location.assign(product.FullProductUrl);

						dispatch(listerClickThrough(product.Code));
					}}
					className="inline-block mb-4"
					itemProp="url"
					data-testid="product-card-link">
					<BrandLogo {...product} />

					<Heading content={product.FullTitle} />
				</a>

				<ReviewRating {...product} />

				<div className="text-right">
					<PricePod
						viewModel={product.PricePodViewModel}
						inStock={product.State !== 'OutOfStock'}
						{...product}
						exVat={true}
					/>
					{!DeliveryPricingInPricePod && <ExVat />}
				</div>

				<PromoFlag {...product} />

				<Bullets content={product.FeatureDescriptions} />

				{product.State !== 'OutOfStock' ? (
					<React.Fragment>
						<DeliveryInformation
							deliveryInformation={product.DynamicDeliveryBulletsViewModel}
						/>

						<AddToBasketButton classes="mt-2" {...product} />

						<MoreInfo classes="mt-2" {...product} />
					</React.Fragment>
				) : (
					<React.Fragment>
						<StockStatus
							stockStatus={product.State}
							productCode={product.Code}
						/>

						<BackInStockButton classes="mt-4" {...product} />
					</React.Fragment>
				)}
			</div>
		</React.Fragment>
	);
};

export default SmallListViewContent;
